import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Grid, withStyles } from '@material-ui/core'

import { isFromUaRouteSelector, routeIdSelector } from 'reduxModules/selectors/RouteSelectors';
import {
  isPartnerSelector,
  isDispatcherSelector,
  isLimitedDispatcherSelector,
  isAdminSelector,
  isPrexBusSelector
} from 'reduxModules/selectors/UserSelectors'
import { Calendar, Routes, BookForm, Bookings, Sources, RouteInfo, Blocking, RouteSummary } from 'components'

const styles = theme => ({
  container: {
    maxWidth: 1280,
    margin: 'auto'
  },
  routes: {
    height: 120,
    maxWidth: 940,
    overflowX: 'scroll'
  },
  bookForm: {
    marginTop: theme.spacing.unit
  },
  sources: {
    flex: 1
  },
  leftSection: {
    width: 348
  },
  bookingsWrapper: {
    width: '100%'
  }
})

class BookPage extends PureComponent {
  render() {
    const { classes, isPartner, isDispatcher, isLimitedDispatcher, routeId, isFromUaRoute, isAdmin } = this.props

    return (
      <Grid
        container
        wrap='nowrap'
        spacing={32}
        component='section'
        className={classes.container}
      >

        <Grid
          item
          container
          spacing={32}
          direction='column'
          className={classes.leftSection}
        >

          <Grid item>
            <Calendar />
          </Grid>

          <Grid item>
            {(!isPartner && !isLimitedDispatcher) && <RouteInfo />}
          </Grid>

          <Grid item>
            <Blocking />
          </Grid>

          <Grid item>
            {routeId
              && !isFromUaRoute
              && this.props.isPrexBus
              && (isAdmin || isDispatcher)
              && (
                <RouteSummary />
              )}
          </Grid>

        </Grid>

        <Grid
          xs
          item
          container
          spacing={16}
          direction='column'
        >

          <Grid
            item
            container
            spacing={8}
            className={classes.routes}
            component='section'
            alignItems='center'
          >
            <Routes />
          </Grid>

          <Grid
            item
            container
            wrap='nowrap'
            spacing={16}
          >
            <Grid item className={classes.bookForm}>
              <BookForm />
            </Grid>
            <Grid item className={classes.sources}>
              {
                isPartner || isLimitedDispatcher
                  ? <RouteInfo />
                  : <Sources />
              }
            </Grid>
          </Grid>

          <Grid item className={classes.bookingsWrapper}>
            <Bookings />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  routeId: routeIdSelector,
  isAdmin: isAdminSelector,
  isPartner: isPartnerSelector,
  isPrexBus: isPrexBusSelector,
  isFromUaRoute: isFromUaRouteSelector,
  isDispatcher: isDispatcherSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export default enhance(BookPage)



// WEBPACK FOOTER //
// ./src/routes/BookPage/BookPage.js